import { createTheme } from "@mui/material";

export const propiedadesDoTema = {
  palette: {
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#d3cdbe" ,
    },
    tertiary: {
      main: "#2d3142"
    },
    quaternary: {
      main: "#4F5D75"
    },
    quinary: {
      main: " #FF6B35"
    },
    primariaEstabelecimento: {
      main: '#4EBC52',
      contrastText: '#ffffff', // Cor do texto contrastante
    },
    secundariaEstabelecimento: {
      main: '#465750',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FF0000',
    },
    warning: {
      main: '#4287f5',
    },
    info: {
      main: '#2196F3',
    },

    success: {
      main: '#4EBC52',
    },
    text: {
      primary: '#000000', // cor do texto principal
      secondary: '#000000', // cor do texto secundário
    },
    background: {
      default: '#465750', // cor de fundo padrão
    },
    action: {
      active: '#4EBC52', // cor do ícone ativo
      hover: '#4EBC52', // cor do ícone ao passar o mouse
      selected: '#eeeeee', // cor do ícone selecionado
      disabled: '#dddddd', // cor do ícone desativado
    },
  },
};

